<template>
  <j-select-biz-component :width="1200" v-bind="configs" v-on="$listeners"/>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectEmTranDoc',
    components: { JSelectBizComponent },
    props: ['value'],
    data() {
      return {
        settings: {
          name: '交易公告',
          displayKey: 'noticeName',
          returnKeys: ['id','id','noticeName'],
          listUrl: '/ebid-ce/emTransferDoc/select/page',
          queryParamCode: 'noticeName',
          queryParamText: '公告名称',
          // 多条件查询配置
          queryConfig: [
            {
              key: 'projectType',
              label: '标的类型',
              // 如果包含 dictCode，那么就会显示成下拉框
              dictCode: 'em_project_type',
            }
          ],
          columns: [
            { title: '公告名称', dataIndex: 'noticeName', align: 'center', width: '25%' },
            { title: '公告编号', dataIndex: 'noticeCode', align: 'center', width: '25%' },
            { title: '出让场次', dataIndex: 'transferSessions', align: 'center', width: '20%' },
            { title: '标的类型', dataIndex: 'projectType', align: 'center', width: '30%' },
          ]
        }
      }
    },
    computed: {
      configs() {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    }
  }
</script>

<style lang="less" scoped></style>